const LabworkType = {
  Internal: 1,
  ByClient: 2,
  ClientDraw: 3,
  QuestPSC: 4,
  QuestClientDraw: 5,
  QuestByClient: 6,
  ByClientI: 7
}

export default LabworkType;